import React, { useState } from "react";
import { FiX } from "react-icons/fi";

const BuildingPlans = () => {
  const sizes = ["25×50", "30×50", "30×60", "30×70", "35×65", "50×90"];
  const [activeTab, setActiveTab] = useState("25×50");
  const [viewFile, setViewFile] = useState(null);

  const designs = {
    "25×50": [
      {
        name: "25×50 Design 1",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765531429/1-25X50_xot0sf.pdf",
      },
      {
        name: "25×50 Design 2",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765531409/2-25x50_mpugsk.pdf",
      },
      {
        name: "25×50 Design 3",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765531412/3-25x50_unthi7.pdf",
      },
      {
        name: "25×50 Design 4",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765531415/4-25X50_ipdqoz.pdf",
      },
      {
        name: "25×50 Design 5",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765531416/5-25X50_rp5fv8.pdf",
      },
      {
        name: "25×50 Design 6",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765531413/6-25X50_s5z4kq.pdf",
      },
    ],
    "30×50": [
      {
        name: "30×50 Design 1",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765531954/30x50_1_v0xnr9.pdf",
      },
      {
        name: "30×50 Design 2",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765531953/30x50_2_gqpzfl.pdf",
      },
      {
        name: "30×50 Design 3",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765531955/30x50_3_kicgb0.pdf",
      },
      {
        name: "30×50 Design 4",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765531956/30x50_4_qgpoir.pdf",
      },
    ],
    "30×60": [
      {
        name: "30×60 Design 1",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765532200/30x60_1_qjabwj.pdf",
      },
      {
        name: "30×60 Design 2",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765532201/30x60_2_s5gya0.pdf",
      },
      {
        name: "30×60 Design 3",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765532209/30x60_3_b4hiyq.pdf",
      },
      {
        name: "30×60 Design 4",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765532205/30x60_4_bivnkx.pdf",
      },
      {
        name: "30×60 Design 5",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765532203/30x60_5_psuoep.pdf",
      },
      {
        name: "30×60 Design 6",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765532203/30x60_6_hfvyy0.pdf",
      },
    ],
    "30×70": [
      {
        name: "30×70 Design 1",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765532941/30X70_1_y4fr2l.pdf",
      },
      {
        name: "30×70 Design 2",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765532990/30X70_2_umf6cm.pdf",
      },
      {
        name: "30×70 Design 3",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765533049/30X70_3_wygnvl.pdf",
      },
      {
        name: "30×70 Design 4",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765533058/30X70_4_m2kueh.pdf",
      },
      {
        name: "30×70 Design 5",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765533055/30X70_5_ajlpup.pdf",
      },
    ],
    "35×65": [
      {
        name: "35×65 Design 1",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765533055/35X65_1_ztwxvq.pdf",
      },
      {
        name: "35×65 Design 2",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765533051/35x65_2_zbmdtq.pdf",
      },
      {
        name: "35×65 Design 3",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765533055/35x65_3_qgll9v.pdf",
      },
      {
        name: "35×65 Design 4",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765533059/35x65_4_c5z6wj.pdf",
      },
      {
        name: "35×65 Design 5",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765533059/35x65_4_c5z6wj.pdf",
      },
    ],
    "50×90": [
      {
        name: "50×90 Design 1",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765533221/50x90_1_nb3x0y.pdf",
      },
      {
        name: "50×90 Design 2",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765533256/50x90_2_a3vmdx.pdf",
      },
      {
        name: "50×90 Design 3",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765533269/50x90_3_ye2mb2.pdf",
      },
      {
        name: "50×90 Design 4",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765533260/50x90_4_ubeduw.pdf",
      },
      {
        name: "50×90 Design 5",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765533269/50x90_5_vrkleo.pdf",
      },
      {
        name: "50×90 Design 6",
        link: "https://res.cloudinary.com/rawalpindidevelopmentauthority/image/upload/v1765533267/50x90_6_jljydd.pdf",
      },
    ],
  };

  return (
    <div className="flex flex-col gap-10  md:py-20 py-10 xl:px-[5%] lg:px-[3%] md:px-[2%] px-[6%] ">
      <div className="flex flex-col gap-4">
        <h1 className="xl:text-[2.5rem] lg:text-[1.8rem]  text-[2rem] font-bold text-center">
          Residential Building <br className=" hidden md:block" /> Plans Library
        </h1>
        <p className="xl:text-[1.2rem] md:text-[1rem] text-[.9rem] text-center text-[#7A7A7A]">
          Please check different residential building plans below for{" "}
          <br className=" hidden md:block" /> reference
        </p>
      </div>
      <div className=" w-full mx-auto flex items-stretch">
        <div className={`flex flex-col w-[30%] ${activeTab} `}>
          {sizes.map((size, i) => (
            <div
              onClick={() => setActiveTab(size)}
              key={i}
              className="flex items-stretch w-full  "
            >
              <div
                className={`flex justify-start items-center lg:text-3xl md:text-2xl sm:text-xl text-lg font-semibold cursor-pointer w-full text-[#000000] md:p-5 p-2  rounded-[1rem] ${
                  activeTab === size
                    ? "bg-[#D9D9D9]  border border-[#00643B]  border-r-0 rounded-r-none "
                    : "bg-[#F6F6F6]  z-10"
                }`}
              >
                {size}
              </div>
              {activeTab === size && (
                <div
                  className={`flex justify-between flex-col bg-[#D9D9D9] -mr-px z-50   border-[#00643B]   mb-[-13px] ${
                    i === 0
                      ? "border-t mt-[0px] "
                      : `mt-[-13px] ${
                          i === sizes.length ? "border-b mb-0 " : " mb-[-13px] "
                        }`
                  } 
                        `}
                >
                  <div
                    className={`top h-[14px] aspect-square mb-[-1px]  ${
                      i === 0
                        ? " "
                        : "border-b border-r rounded-br-[1rem] border-[#00643B]  bg-[#F6F6F6] "
                    } `}
                  ></div>

                  <div
                    className={`bottom  h-[14px] aspect-square mt-[-1px]   ${
                      i === size.length
                        ? " border-t border-[#00643B] bg-[#F6F6F6]"
                        : "border-t border-r rounded-tr-[1rem] border-[#00643B]  bg-[#F6F6F6]"
                    } `}
                  ></div>
                </div>
              )}
            </div>
          ))}
        </div>
        <div
          className={` w-[70%] bg-[#D9D9D9] border z-0 ${
            activeTab === sizes[0]
              ? "rounded-tl-none rounded-[1rem]"
              : activeTab === sizes[sizes.length - 1]
              ? "rounded-bl-none rounded-[1rem]"
              : "rounded-[1rem]"
          } md:p-5 p-3 border-[#00643B] flex flex-col gap-2`}
        >
          {designs[activeTab]?.map((design, index) => (
            <li
              key={index}
              onClick={() =>
                setViewFile({
                  url: design?.link,
                  name: design?.name,
                })
              }
              className="flex items-center cursor-pointer gap-2 lg:text-3xl md:text-2xl sm:text-xl text-lg font-semibold text-[#00643B]"
            >
              <span className="w-1.5 h-1.5 bg-[#00643b] rounded-full"></span>
              {design?.name}
            </li>
          ))}
        </div>
      </div>
      {viewFile && (
        <div className="fixed inset-0 bg-black bg-opacity-10 backdrop-blur-sm h-screen flex items-center justify-center z-[200]">
          <div className="relative bg-white/80 border border-white/30 backdrop-blur-lg rounded-2xl shadow-xl p-4  w-[90%] h-[95vh]  animate-fade-in text-black">
            <button
              onClick={(e) => {
                e.stopPropagation();
                setViewFile(null);
              }}
              className="absolute top-4 right-4 text-[#00643b]"
              aria-label="Close modal"
            >
              <FiX className="size-6" />
            </button>
            <h2 className="text-[1.5rem] font-bold lg:mb-4 mb-3 text-[#00643b]">
              Building Plan {viewFile?.name}
            </h2>

            <iframe
              src={viewFile.url}
              width="100%"
              height="90%"
              className="rounded-[1rem] mt-2"
              title="PDF Preview"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default BuildingPlans;
